import { useEffect, useRef } from 'react';

interface UseFocusableRefOptions {
  isEnabled?: boolean;
  delay?: number;
}

export const useFocusableRef = (selector: string, { isEnabled = false, delay = 300 }: UseFocusableRefOptions = {}) => {
  const cardRef = useRef<HTMLElement | null>(null);
  const hasAutoFocused = useRef(false);

  useEffect(() => {
    if (!isEnabled || hasAutoFocused.current || !cardRef.current) {
      return;
    }

    hasAutoFocused.current = true;

    cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });

    const timer = setTimeout(() => {
      if (!cardRef.current) {
        return;
      }

      const el = cardRef.current.querySelector<HTMLElement>(selector);
      if (el && typeof el.focus === 'function') {
        el.focus({ preventScroll: true });
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [isEnabled, selector, delay]);

  return cardRef;
};
